export const colors = {
  LOGOWHITE: '#E6E6E6',
  WHITE: "#FFFFFF",
  TEAL: "#7EA1A9"
}